import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CenteredCard } from '../components/ui';
import { postJSON } from '../lib/api';
import { CONTACT_EMAIL } from '../lib/legal';

const FALLBACK = `mailto:${CONTACT_EMAIL}?subject=Unsubscribe`;

// The email goes in the request body, never the URL. If the request fails, the
// page says so and offers email instead: it must never claim an opt-out that
// did not happen.
const Unsubscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await postJSON('/unsubscribe', { email });
      setStatus('done');
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <CenteredCard>
      <h1 className="text-3xl md:text-4xl font-bold tracking-tighter uppercase text-zinc-900 mb-4">Unsubscribe</h1>
      {status === 'done' ? (
        <p role="status" className="text-sm md:text-base text-zinc-600 leading-relaxed mb-10">
          You're unsubscribed from Korsa marketing email. You may still get messages about an order you placed.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="text-left space-y-4 mb-10">
          <div>
            <label htmlFor="unsubscribe-email" className="block text-sm font-bold text-zinc-800 mb-2">Email address</label>
            <input
              id="unsubscribe-email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="glass-input w-full px-5 py-3.5"
            />
          </div>
          <button type="submit" disabled={status === 'sending'} className="btn-dark w-full">
            {status === 'sending' ? 'Sending...' : 'Unsubscribe'}
          </button>
          {status === 'error' && (
            <p role="alert" className="text-sm font-bold text-red-700">
              Error: that didn't go through, and you are not unsubscribed yet. Please email{' '}
              <a href={FALLBACK} className="underline underline-offset-2">{CONTACT_EMAIL}</a> with the subject Unsubscribe.
            </p>
          )}
        </form>
      )}
      <Link to="/" className="text-[10px] font-bold uppercase tracking-widest text-zinc-600 hover:text-zinc-900 transition-colors">
        Back to home →
      </Link>
    </CenteredCard>
  );
};

export default Unsubscribe;
